import { i18n } from 'i18n';

export const ROUTE_PATH = '/invitations';
export const TITLE = i18n._('Invites');
